import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import { showSpinner, hideSpinner } from '../../reducers/UiReducer';
import { handleError } from '../../reducers/ErrorReducer';
import { notify } from '../../reducers/NotifierReducer';
import TextField from '@material-ui/core/TextField';

import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {
  testEmail,
  testSMS,
  savePagingSettings,
  getPagingSettings,
  getFireHornSetting,
  sendTofireHornAPI,
  removeAssignedRecipient,
  getFireHornAssignAgencycounts,
} from '../../reducers/PagingReducer';
import { validateEmail } from '../../utils/functions';
import { CircularProgress } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import Fab from '@material-ui/core/Fab';
import options from 'components/IconsAgency';
import { getService } from 'reducers/service';
import QuickFilterSearch from 'components/QuickFilterSearch';
import XGrid3 from 'components/XGrid3';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

function getFormStyle(minWidth, maxWidth) {
  return {
    maxWidth: maxWidth,
    flexBasis: minWidth,
    minWidth: minWidth,
    flexGrow: 1,
    margin: `0 4px 8px`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '& h4': {
      marginBottom: theme.spacing(2),
      overflow: 'hidden',
    },
  },
  table: {
    minWidth: 150,
    maxWidth: 200,
    '& td': {
      paddingTop: 2,
      paddingBottom: 2,
    },
  },
  actions: {
    //textAlign: 'right',
    marginTop: 30,
    '& button': {
      '& svg': {
        marginRight: theme.spacing(1),
      },
    },
  },
  form: {
    margin: `0 -${theme.spacing(0.5)}px`,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
    maxWidth: 400,
  },
  emailTest: {
    margin: `0 -${theme.spacing(0.5)}px`,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
    maxWidth: 400,
    justifyContent: 'space-between',
    '& button': {
      marginBottom: theme.spacing(1),
    },
  },
  radioGroup: {
    width: '100%',
  },
  textField: {
    ...getFormStyle(200, 300),
  },
  testField: {
    ...getFormStyle(200, 300),
  },
  w100pr: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  checkbox: {
    // margin: `-${theme.spacing(0.5)}px ${theme.spacing(0.5)}px 0`,
  },
  loading: {
    textAlign: 'center',
    zIndex: 9999,
    position: 'absolute',
    top: '40%',
    left: '40%',
  },
}));

const iconRender = params => {
  const Icon = options[params.value];
  return Icon ? <Icon /> : ' ';
};

const defaultColumns = [
  { field: 'AgencyID', headerName: 'Agency ID' },
  { field: 'Description', headerName: 'Description' },
  { field: 'Icon', headerName: 'Icon', renderCell: iconRender },
  { field: 'Police', headerName: 'Police', format: 'bool' },
  { field: 'Fire', headerName: 'Fire', format: 'bool' },
  { field: 'EMS', headerName: 'EMS', format: 'bool' },
  { field: 'fireHornEnable', headerName: 'FireHorn Enabled', format: 'bool', width: 180 },
  { field: 'fireHornNoofrecipient', headerName: 'Total License' },
  { field: 'usedLicense', headerName: 'Used License' },
  { field: 'remainingLicense', headerName: 'Remaining License', width: 180 },
];

function SMTPSettings(props) {
  const classes = useStyles();
  const [sendgridFrom, setSendgridFrom] = useState('');
  const [sendgridKey, setSendgridKey] = useState('');
  const [emailTo, setEmailTo] = useState('');
  const [twilioSid, setTwilioSid] = useState('');
  const [twilioKey, setTwilioKey] = useState('');
  const [twilioMsgSSid, setTwilioMsgSSid] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [smtpValid, setSmtpValid] = useState(false);
  const [fireHornEnabled, setFireHornEnabled] = useState(false);
  const [numberOfRecipientsError, setNumberOfRecipientsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { dataUpdate } = props;
  const service = getService('cad-search-agencies');
  const cdrService = getService('settings-agency-cad');
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selection, setselection] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [agencyColumns, setAgencyColumns] = useState(defaultColumns);
  const [printFlag, setPrintFlag] = useState(false);
  const [fireHornKey, setFireHornKey] = useState('');
  const [numberOfRecipients, setNumberOfRecipients] = useState(0);
  const [fireHornAgencyId, setFireHornAgencyId] = useState('');
  const [totalRecipients, setTotalRecipients] = useState('');
  const [totalRecipientsLimit, setTotalRecipientsLimit] = useState(0);
  const [totalRecipientsLimitError, setTotalRecipientsLimitError] = useState('');
  const [fireHornSetting, setFireHornSetting] = useState(null);
  const [isSaveDisabled, setIsSaveDisabled] = useState(null);
  const [isFireHornSaveDisabled, setIsFireHornSaveDisabled] = useState(null);
  const [assignedLicenses, setAssignedLicenses] = useState(null);
  useEffect(() => {
    getAgencyData();
  }, []);

  useEffect(() => {
    if (dataUpdate && dataUpdate.type === 'agencies') getAgencyData();
  }, [dataUpdate]);

  useEffect(() => {
    if (!fireHornEnabled) {
      setNumberOfRecipientsError(false);
      setIsFireHornSaveDisabled(false);
      return;
    }
    const inputValue = Number(numberOfRecipients || 0);
    if (!inputValue || inputValue <= 0) {
      setNumberOfRecipientsError('This field is required.');
      setIsFireHornSaveDisabled(true);
      return;
    }
    const assignedLicense = assignedLicenses[selection.toLowerCase()] ?? 0;
    if (inputValue < assignedLicense) {
      setNumberOfRecipientsError('Limit cannot be lower than already assigned licenses.');
      setIsFireHornSaveDisabled(true);
      return;
    }

    const otherAgencyTotal = fireHornSetting
      .filter(a => a.agency.toLowerCase() !== selection.toLowerCase())
      .reduce((sum, a) => sum + Number(a.noofrecipient || 0), 0);
    const newTotal = otherAgencyTotal + inputValue;
    if (newTotal > totalRecipientsLimit) {
      setNumberOfRecipientsError('Total licenses limit exceeded.');
      setIsFireHornSaveDisabled(true);
    } else {
      setNumberOfRecipientsError(false);
      setIsFireHornSaveDisabled(false);
    }
  }, [fireHornEnabled, numberOfRecipients, selection, totalRecipientsLimit]);

  useEffect(() => {
    const isInvalid = totalRecipientsLimit < totalRecipients;
    setTotalRecipientsLimitError(isInvalid);
    setIsSaveDisabled(isInvalid);
  }, [totalRecipientsLimit, totalRecipients]);

  const getAgencyData = async () => {
    const data = await service.find({
      query: {
        originSettings: true,
      },
    });
    var fireHornSetting = await getFireHornSetting();
    setFireHornSetting(fireHornSetting);
    const totalRecipients = fireHornSetting.reduce(
      (sum, setting) => sum + Number(setting.noofrecipient || 0),
      0
    );
    setTotalRecipients(totalRecipients);
    const recipientService = getService('pagrecipient');
    const recipients = await recipientService.find({
      query: { IsDeleted: false, $sort: { Created: -1 }, $limit: 0 },
    });
    const assignedLicenses = getFireHornAssignAgencycounts(recipients?.data || {});
    setAssignedLicenses(assignedLicenses);
    setRows(processData(data, fireHornSetting, assignedLicenses));
  };

  const processData = (data, fireHornSetting, assignedLicenses) => {
    return (data || [])
      .filter(row => row && row.IsDeleted === false)
      .map(row => {
        const agencyId = row.AgencyID?.toLowerCase() || '';
        const agencySettings =
          fireHornSetting.find(x => x.agency?.toLowerCase() === agencyId) || {};

        const assignedLicense = assignedLicenses[agencyId] ?? 0;
        const totalRecipient = Number(agencySettings.noofrecipient) || 0;
        const usedLicense = `${assignedLicense} `;
        const remainingLicense = `${totalRecipient - assignedLicense}`;
        return {
          ...row,
          fireHornEnable: agencySettings.enable || false,
          fireHornNoofrecipient: totalRecipient,
          fireHornAgencyId: agencySettings.AgencyId || '',
          usedLicense: usedLicense,
          remainingLicense: remainingLicense,
          id: row.AgencyID,
        };
      });
  };

  useEffect(() => {
    getSettings();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    validateSMTP();
    // eslint-disable-next-line
  }, [sendgridFrom, sendgridKey, emailTo]);

  const getSettings = async () => {
    props.showSpinner();
    try {
      const settings = await getPagingSettings();
      const {
        sendgridKey,
        sendgridFrom,
        twilioSid,
        twilioKey,
        twilioMsgSSid,
        fireHornKey,
        totalRecipientsLimit,
      } = settings;
      setSendgridFrom(sendgridFrom);
      setSendgridKey(sendgridKey);
      setTwilioKey(twilioKey);
      setFireHornKey(fireHornKey);
      setTwilioSid(twilioSid);
      setTwilioMsgSSid(twilioMsgSSid);
      setTotalRecipientsLimit(totalRecipientsLimit);
    } catch (err) {
      props.handleError(err, 'Error, cannot load settings.');
    }
    props.hideSpinner();
  };

  const validateSMTP = () => {
    let valid = true;
    if (!sendgridFrom || !sendgridKey || !emailTo) valid = false;
    if (sendgridFrom && !validateEmail(sendgridFrom)) valid = false;
    if (emailTo && !validateEmail(emailTo)) valid = false;
    valid !== smtpValid && setSmtpValid(valid);
  };

  const save = async () => {
    const data = {
      sendgridFrom,
      sendgridKey,
      twilioKey,
      twilioSid,
      twilioMsgSSid,
      fireHornKey,
      totalRecipientsLimit,
    };
    props.showSpinner();
    try {
      await savePagingSettings(data);
      props.notify('Settings saved', 'success');
    } catch (err) {
      props.handleError(err, 'Error, settings not saved');
    }
    props.hideSpinner();
  };

  const onTestEmail = async () => {
    const mail = {
      sendgridFrom,
      sendgridKey,
      Subject: 'E-mail test from CAD app',
      Body: 'Your CAD email service has been setup correctly.',
      emailTo,
    };
    props.showSpinner();
    try {
      await testEmail(mail);
      props.notify('E-mail has been sent, please check you mailbox.');
    } catch (err) {
      props.notify('Error, e-mail not sent', 'error');
      console.log(err);
    }
    props.hideSpinner();
  };

  const onTestSMS = async () => {
    const mail = {
      twilioKey,
      twilioSid,
      twilioMsgSSid,
      twilioTo: phoneNo,
      Body: 'Your CAD SMS service has been setup correctly.',
    };
    props.showSpinner();
    try {
      await testSMS(mail);
      props.notify('E-mail has been sent, please check you mailbox.');
    } catch (err) {
      props.notify('Error, e-mail not sent', 'error');
      console.log(err);
    }
    props.hideSpinner();
  };

  const renderSendgridSettings = () => {
    return (
      <div className={classes.form}>
        <TextField
          className={classes.w100pr}
          label="E-mail From"
          value={sendgridFrom}
          onChange={ev => setSendgridFrom(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          className={classes.w100pr}
          label="Sendgrid key"
          value={sendgridKey}
          onChange={ev => setSendgridKey(ev.target.value)}
          variant="outlined"
          size="small"
          type="password"
          inputProps={{
            autoComplete: 'new-password',
            form: { autoComplete: 'off' },
          }}
        />
      </div>
    );
  };

  const renderTwilioSettings = () => {
    return (
      <div className={classes.form}>
        <TextField
          className={classes.w100pr}
          label="Message Service SID"
          value={twilioMsgSSid}
          onChange={ev => setTwilioMsgSSid(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          className={classes.w100pr}
          label="Account SID"
          value={twilioSid}
          onChange={ev => setTwilioSid(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          className={classes.w100pr}
          label="Auth Token"
          value={twilioKey}
          onChange={ev => setTwilioKey(ev.target.value)}
          variant="outlined"
          size="small"
          type="password"
          inputProps={{
            autoComplete: 'new-password',
            form: { autoComplete: 'off' },
          }}
        />
      </div>
    );
  };

  const renderFireHornSettings = () => {
    return (
      <div className={classes.form}>
        <TextField
          className={`${classes.w100pr}`}
          label="Auth Token"
          value={fireHornKey}
          onChange={ev => setFireHornKey(ev.target.value)}
          variant="outlined"
          size="small"
          type="password"
        />
        <TextField
          className={`${classes.w100pr}`}
          label="Total Available License"
          value={totalRecipientsLimit}
          onChange={ev => setTotalRecipientsLimit(ev.target.value)}
          variant="outlined"
          size="small"
          error={totalRecipientsLimitError}
          helperText={
            totalRecipientsLimitError ? 'Total licenses cannot be less than assigned License.' : ''
          }
        />
        <h6 style={{ marginLeft: 4, fontSize: '0.9rem', color: '#3f3f3f' }}>
          Assigned: {totalRecipients} | Available:
          {totalRecipientsLimit - totalRecipients}
        </h6>
      </div>
    );
  };

  const renderEmailTest = () => {
    return (
      <div className={classes.emailTest}>
        <TextField
          className={classes.testField}
          label="E-mail"
          value={emailTo}
          onChange={ev => setEmailTo(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <div className={classes.btnWrap}>
          <Button variant="contained" color="primary" onClick={onTestEmail} disabled={!smtpValid}>
            Test
          </Button>
        </div>
      </div>
    );
  };

  const renderSMSTest = () => {
    return (
      <div className={classes.emailTest}>
        <TextField
          className={classes.testField}
          label="+1 xxx xxx xxx xxx"
          value={phoneNo}
          onChange={ev => setPhoneNo(ev.target.value)}
          variant="outlined"
          size="small"
        />
        <div className={classes.btnWrap}>
          <Button
            variant="contained"
            color="primary"
            onClick={onTestSMS}
            disabled={!twilioSid || !twilioKey || !twilioMsgSSid || !phoneNo}>
            Test
          </Button>
        </div>
      </div>
    );
  };

  const renderAgencyGrid = () => {
    return (
      <div>
        <div className={classes.filterWrap}>
          <div className={classes.filterWrap}>
            <QuickFilterSearch
              rows={rows}
              columns={agencyColumns}
              setFilteredRows={setFilteredRows}
              style={{ marginTop: 5 }}
            />
          </div>
        </div>
        <XGrid3
          columns={agencyColumns}
          setColumns={setAgencyColumns}
          rows={filteredRows}
          setSelection={handleSelection}
          printFlag={printFlag}
          refresh={getAgencyData}
          xgridHeight={380}
        />
      </div>
    );
  };

  const formatSaveData = fhAgencyId => {
    return [
      {
        Path: `${selection}.CAD.FireHorn.Enable`,
        CDRKey: 'CAD FireHorn',
        ValueBoolean: fireHornEnabled,
      },
      {
        Path: `${selection}.CAD.FireHorn.NumberOfRecipients`,
        CDRKey: 'CAD FireHorn',
        ValueString: fireHornEnabled ? numberOfRecipients?.toString() ?? '' : '',
      },
      {
        Path: `${selection}.CAD.FireHorn.AgencyId`,
        CDRKey: 'CAD FireHorn',
        ValueString: fhAgencyId ?? '',
      },
    ];
  };

  const handleSelection = newSelection => {
    setselection(newSelection);
    var data = rows.find(x => x.id.toLowerCase() === newSelection.toLowerCase());
    if (data) {
      setFireHornEnabled(data.fireHornEnable);
      setNumberOfRecipients(parseInt(data.fireHornNoofrecipient, 10) || 0);
      setFireHornAgencyId(data.fireHornAgencyId);
    } else {
      setFireHornEnabled(false);
      setNumberOfRecipients(0);
      setFireHornAgencyId('');
    }
    setOpenDialog(true);
  };

  const handleSave = async () => {
    let fhAgencyId = '';
    try {
      setLoading(true);
      var fhAgencies = await sendTofireHornAPI('GET', 'agencies');
      const match = fhAgencies.agency.find(
        a => a.agency_uuid === fireHornAgencyId || a.name === selection
      );
      if (match) {
        fhAgencyId = match.agency_uuid;
        if (
          (fireHornEnabled && match.active === 'inactive') ||
          (!fireHornEnabled && match.active === 'active')
        ) {
          let apiUrl = `agencies/${fhAgencyId}/${fireHornEnabled ? 'reactivate' : 'deactivate'}`;
          await sendTofireHornAPI('PATCH', apiUrl, null);
        }
      } else {
        var fhagency = await sendTofireHornAPI('POST', 'agencies', {
          Agency_Name: selection,
        });
        if (
          fhagency.result === 'SUCCESS' &&
          Array.isArray(fhagency.agency) &&
          fhagency.agency.length > 0
        ) {
          fhAgencyId = fhagency.agency[0].new_uuid;
          setFireHornAgencyId(fhAgencyId);
        }
      }
      const saveObj = formatSaveData(fhAgencyId);
      if (!fireHornEnabled) {
        removeAssignedRecipient(selection);
      }
      await cdrService.create(saveObj);
      props.notify('FireHorn Settings Saved.', 'success');
      setOpenDialog(false);
      getAgencyData();
    } catch (err) {
      props.handleError(err, 'Error Saving FireHorn Settings.');
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <div className={classes.root}>
      <h4>Setup Credential</h4>
      <Grid container item xs={12} spacing={2}>
        <Grid item xs={3}>
          <h5>E-mail Settings</h5>
          <h6>Sendgrid</h6>
          {renderSendgridSettings()}
          <div className={classes.actions}>
            <Button color="primary" disabled={isSaveDisabled} variant="contained" onClick={save}>
              <SaveIcon /> Save
            </Button>
          </div>
        </Grid>
        <Grid item xs={3}>
          <h5>SMS Settings</h5>
          <h6>Twilio</h6>
          {renderTwilioSettings()}
        </Grid>
        <Grid item xs={3}>
          <h5>SMS Settings</h5>
          <h6>FireHorn</h6>
          {renderFireHornSettings()}
        </Grid>
        <Grid item xs={3}>
          <h5>Test Email and SMS</h5>
          <h6>Test E-mail Service</h6>
          {renderEmailTest()}
          <h6>Test SMS Service</h6>
          {renderSMSTest()}
        </Grid>
      </Grid>
      <hr />
      <h5>FireHorn SMS Setting</h5>
      <h5>Agencies</h5>
      {renderAgencyGrid()}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{selection ? selection : 'Agency Settings'}</DialogTitle>
        <DialogContent dividers>
          {loading && (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          )}
          <FormControlLabel
            label="FireHorn Enabled"
            control={
              <Checkbox
                checked={fireHornEnabled}
                onChange={ev => setFireHornEnabled(ev.target.checked)}
                label="FireHorn Enabled"
              />
            }
          />
          <br />
          <TextField
            className={classes.w100pr}
            label="Number Of License"
            value={numberOfRecipients}
            onChange={ev =>
              setNumberOfRecipients(ev.target.value === '' ? '' : Number(ev.target.value))
            }
            variant="outlined"
            disabled={!fireHornEnabled}
            size="small"
            error={numberOfRecipientsError}
            helperText={numberOfRecipientsError ? numberOfRecipientsError : ''}
            type="number"
            inputProps={{ min: 0 }}
          />
          <br />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSave}
            disabled={loading || isFireHornSaveDisabled}>
            <SaveIcon /> Save
          </Button>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default connect(null, {
  showSpinner,
  hideSpinner,
  handleError,
  notify,
})(SMTPSettings);
